import { ActionReducer, createReducer, on } from '@ngrx/store';
import { CartState, initialState } from './cart.state';
import {
  clearLastAddedItem,
  getCart,
  getCartFailure,
  getCartShortInfo,
  getCartShortInfoFailure,
  getCartShortInfoSuccess,
  getCartSuccess,
  getMarkupSettings,
  getMarkupSettingsFailure,
  getMarkupSettingsSuccess,
  setLastAddedItem,
} from './cart.actions';

export const cartReducer: ActionReducer<CartState> = createReducer(
  initialState,
  on(getCart, (state: CartState) => {
    return { ...state, loading: true };
  }),
  on(getCartSuccess, (state: CartState, { cart }) => {
    return { ...state, cart, loading: false };
  }),
  on(getCartFailure, (state: CartState) => {
    return { ...state, loading: false };
  }),
  on(setLastAddedItem, (state: CartState, { item }) => {
    return { ...state, lastAddedItem: item };
  }),
  on(clearLastAddedItem, (state: CartState) => {
    return { ...state, lastAddedItem: null };
  }),
  on(getCartShortInfo, (state: CartState) => {
    return { ...state, loading: true };
  }),
  on(getCartShortInfoSuccess, (state: CartState, { info }) => {
    return { ...state, shortInfo: info, cartId: info.cartId, loading: false };
  }),
  on(getCartShortInfoFailure, (state: CartState) => {
    return { ...state, loading: false };
  }),
  on(getMarkupSettings, (state: CartState) => {
    return { ...state, markupLoading: true };
  }),
  on(getMarkupSettingsSuccess, (state: CartState, { markupSettings }) => {
    return { ...state, markupSettings, markupLoading: false };
  }),
  on(getMarkupSettingsFailure, (state: CartState) => {
    return {
      ...state,
      markupLoading: false,
    };
  }),
);
